import { Children, ReactNode } from "react"
import { AnimatePresence, motion } from "framer-motion"
import "./WizardSection.scss"
import { slideInOut } from "./WizardAnimation"

export const WizardSection = (props: { visible: boolean; children: ReactNode; className?: string }) => (
  <AnimatePresence>
    {props.visible && (
      <div className={`WizardSection ${props.className || ""}`}>
        {Children.map(props.children, (node, i) => (
          <motion.div className="step-item" {...slideInOut(i)} key={`section-${i}`}>
            {node}
          </motion.div>
        ))}
      </div>
    )}
  </AnimatePresence>
)
